module.exports = __webpack_public_path__ + "static/img/_logo.b82d875.png";


//////////////////
// WEBPACK FOOTER
// ./resources/holataxi/img/_logo.png
// module id = GdqY
// module chunks = 1